import React from "react";
import PropTypes from "prop-types";

import MuiListItem from "@mui/material/ListItem";

const ListItem = (props) => {
  const {
    LeadComponent,
    TrailComponent,
    ContentComponent,
    variant,
    className,
  } = props;

  return (
    <MuiListItem
      secondaryAction={TrailComponent}
      variant={variant}
      className={className}
    >
      {LeadComponent}
      {ContentComponent}
    </MuiListItem>
  );
};

ListItem.propTypes = {
  LeadComponent: PropTypes.element,
  ContentComponent: PropTypes.any,
  TrailComponent: PropTypes.element,
  variant: PropTypes.string,
  className: PropTypes.string,
};

export default ListItem;
